import { addHexPrefix } from './addHexPrefix';
export var hexlify = function hexlify(input) {
  return addHexPrefix(input.toString(16));
};